// extracted by css-extract-rspack-plugin
export default {"field":"boEOt1pv36wWPkUg"};